module.exports = __webpack_public_path__ + "static/img/image_recruit_11.e54fb43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/join/image_recruit_11.png
// module id = kx1B
// module chunks = 10